export default __webpack_public_path__ + "static/media/1833.d6e121ba.png";